import { SheetPresence } from './SheetMotion';
// © 2025 COPYright LAHO – https://www.linkedin.com/in/laurens-holtkamp-7a686b2b/
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Plus, Menu } from 'lucide-react';
import { useState } from 'react';
import UserMenu from './UserMenu';
import useOpenSettlements from '../hooks/useOpenSettlements';
import { isNativeApp } from '../lib/platform';
import { preloadPrimaryPage } from '../lib/primaryPages';

const BottomNavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const { openCount } = useOpenSettlements();
  const isMoreRoute = ['/log', '/leaderboard', '/profile', '/admin', '/settlements', '/stats'].includes(pathname);
  const itemClass = 'flex min-h-12 min-w-0 flex-col items-center justify-center gap-1.5 w-full justify-self-center rounded-xl px-2 py-2 outline-none focus-visible:ring-2 focus-visible:ring-primary/50';

  return (
    <>
      <nav
        data-native-tabs
        className="fixed inset-x-0 bottom-0 z-40 border-t border-zinc-200 bg-white/95 pt-2 pb-[calc(8px+env(safe-area-inset-bottom))] backdrop-blur dark:border-zinc-800 dark:bg-zinc-950/95"
        aria-label="Hoofdnavigatie"
      >
        <div className="relative mx-auto grid min-h-16 max-w-3xl grid-cols-3 items-end px-4">
          <NavLink replace={isNativeApp()} to="/app" onPointerEnter={() => preloadPrimaryPage('/app')} onFocus={() => preloadPrimaryPage('/app')} className={({ isActive }) => `${itemClass} ${isActive ? 'text-primary' : 'text-zinc-500 dark:text-zinc-400'}`}>
            <span className="relative">
              <Home className="h-6 w-6" aria-hidden="true" />
              {openCount > 0 && (
                <span className="absolute -right-3 -top-1 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-amber-500 px-1 text-[10px] font-bold text-zinc-950">
                  <span aria-hidden="true">{openCount}</span>
                  <span className="sr-only">{openCount} openstaande verrekeningen</span>
                </span>
              )}
            </span>
            <span className="max-w-full break-words text-xs leading-tight">Overzicht</span>
          </NavLink>
          <NavLink replace={isNativeApp()} to="/input" onPointerEnter={() => preloadPrimaryPage('/input')} onFocus={() => preloadPrimaryPage('/input')} className={({ isActive }) => `-mt-6 flex min-w-0 flex-col items-center gap-1.5 w-full justify-self-center rounded-xl px-2 py-2 outline-none focus-visible:ring-2 focus-visible:ring-primary/50 ${isActive ? 'text-primary' : 'text-zinc-500 dark:text-zinc-400'}`}>
            <span className="grid h-[56px] w-[56px] place-items-center rounded-full bg-primary text-white shadow-md shadow-primary/20 transition hover:bg-primary-dark active:scale-95">
              <Plus className="h-[32px] w-[32px]" strokeWidth={2.5} aria-hidden="true" />
            </span>
            <span className="max-w-full break-words text-xs font-semibold leading-tight">Toevoegen</span>
          </NavLink>
          <button type="button" aria-haspopup="dialog" aria-expanded={menuOpen} aria-controls={menuOpen ? 'user-menu-sheet' : undefined} onClick={() => setMenuOpen(true)} className={`${itemClass} ${menuOpen || isMoreRoute ? 'text-primary' : 'text-zinc-500 dark:text-zinc-400'}`}>
            <Menu className="h-6 w-6" aria-hidden="true" />
            <span className="max-w-full break-words text-xs leading-tight">Meer</span>
          </button>
        </div>
      </nav>
      <SheetPresence>{menuOpen && <UserMenu onClose={() => setMenuOpen(false)} />}</SheetPresence>
    </>
  );
};

export default BottomNavBar;
